// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1RgDN","text":"SelectPayment_text__31xw2","title":"SelectPayment_title__Ba3nz","btn":"SelectPayment_btn__7HBwy"};